import styled from 'styled-components';

export const ListingLocationLabelHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
